// TODO: 这里可以考虑把不通的错误类型写到不同的文件里面，然后在这里统一导入;
const ExceptionCodes = {
  0: '成功',
  // errors:
  10001: '用户名或密码错误',
  10002: '用户名或密码错误',
  10003: '该用户不存在',
  10004: '用户名为空',
  10005: '用户名重复',
  10006: '新密码和原密码不能相同',
  10007: '当前用户未绑定邮箱，请联系管理员找回密码',
  10008: '登录失败',
  10009: '软件试用已到期，升级正式版后方可继续使用...',
  10010: '软件与服务器不匹配',
  10011: '请插入加密狗',
  10012: '加密狗不匹配',
  10013: '该账号已过期，请联系管理员',
  10014: '用户有效期不得大于当前登录人的有效期',

  10017: '请求超时',
  10018: '请求数据安全校验失败',

  10020: '验证码错误',
  10021: '密码为空',
  10022: '姓名为空',

  10024: '企业编码为空',
  10025: '企业不存在',
  10026: '企业未绑定邮箱，请联系平台管理员',
  10027: '当前用户未绑定邮箱，请联系企业管理员',
  10028: '密码验证错误',
  10029: '软件使用已到期，请联系平台管理员',
  10031: '上传图片格式不正确',
  10032: '不是有效的图片文件',
  10033: '上传图片超出大小限制',

  11001: '该部门不存在',
  11002: '部门名称为空',
  11003: '部门名称重复',
  11004: '超出同级别部门数量限制（同级部门最多允许999个）',
  11005: '超出部门级别限制（最多允许10级部门）',
  11006: '该部门下有工作人员，不能删除',
  11007: '该部门下有锁，不能删除',
  11008: '未选择部门',

  11009: '父部门不存在',

  11010: '部门名称程度大于50字符',
  11011: '该部门下有钥匙，不能删除',
  11012: '不能删除自己所在部门',
  11013: '该部门下有用户，不能删除',

  12001: '该工作人员不存在',
  12002: '工作人员名称为空',
  12003: '工作人员名称重复',
  12004: 'APP用户名重复',
  12005: '用户有领出的钥匙未归还，不能删除',
  12007: '用户处于任务中，不能删除',
  12010: '该用户有指纹类钥匙未归还，不能删除其指纹',
  12011: '该用户处于任务中，不能删除其指纹',

  13001: '该用户身份不存在',
  13002: '用户身份名称为空',
  13003: '用户身份名称重复',
  13004: '该用户身份为系统默认身份，不能删除',
  13005: '该用户身份下有用户，不能删除',
  13006: '未选择身份',
  13007: '该用户身份为系统默认身份，不能修改',

  14001: '该锁信息不存在',
  14002: '锁编号为空',
  14003: '锁名称为空',
  14004: '该锁已存在所选部门，无法重复添加', // 本部门
  14005: '锁名称重复',
  14006: '该锁已存在其他部门，无法重复添加', // 其他部门
  14007: '锁号超出范围(1-65500)',
  14008: '锁硬件编号重复',
  14009: '锁处于任务中，不能删除',
  14010: '该开关锁记录不存在',
  14011: '锁与机柜已关联，不能删除',
  14013: '添加失败，锁具数量超出授权数量，如需添加新锁，请增加授权数量',

  15001: '该钥匙信息不存在',
  15002: '钥匙编号为空',
  15003: '钥匙名称为空',
  15004: '钥匙编号重复',
  15005: '钥匙名称重复',
  15006: '钥匙有效期为空',
  15007: '不是正常状态的钥匙，不能被领出',
  15008: '不是领出状态的钥匙，不能被归还',
  15009: '不是领出状态的钥匙，不能被挂失',
  15010: '不是丢失状态的钥匙，不能解除挂失',
  15011: '该钥匙领出记录不存在',
  15012: '不能删除领出状态的钥匙',
  15020: '无钥匙所在部门权限，无权操作该钥匙',
  15021: '该任务已审核通过',
  15022: '该任务已被驳回',
  15023: '该任务已过期',
  15029: '任务锁列表为空',
  15030: '该钥匙正在工作中，请先上传开关锁记录及清空相关任务后再进行删除操作',
  15031: '其他企业钥匙，无操作权限',
  15032: '钥匙授权时间为空',
  15033: '钥匙过期时间为空',
  15034: '不支持的钥匙类型',
  15035: '钥匙部门下无用户信息',
  15042: '任务用户为空',

  16001: '无导出数据',
  16002: '导出失败',
  16003: '下载模板失败',
  16004: '导入失败',
  16005: '导入文件格式不正确',
  16006: '无导入数据',
  16007: '导入模板不匹配',

  16008: '下载通讯组件失败',
  16009: '导出数据大于10万条，请缩小查询范围',

  16010: '导入的用户名为空',
  16011: '导入的用户身份为空',
  16012: '导入的用户名大于20个字符',
  16013: '导入的电话大于50个字符',
  16014: '导入的邮箱大于50个字符',
  16015: '导入的用户名有重复',
  16016: '导入的用户身份在系统中不存在',
  16017: '导入的姓名为空',
  16018: '导入的姓名大于50个字符',
  16019: '导入的邮箱格式不正确',

  16101: '导入的工作人员名称为空',
  16102: '导入的工作人员名称大于50个字符',
  16103: '导入的工作人员APP登录名大于20个字符',
  16104: '导入的工作人员联系电话大于50个字符',
  16105: '导入的工作人员联系地址大于100个字符',
  16106: '导入的工作人员名称在同部门下有重复',
  16107: '导入的工作人员APP登录名有重复',

  16201: '导入的锁名称为空',
  16202: '导入的锁编号为空',
  16203: '导入的锁状态为空',
  16204: '导入的锁名称大于50个字符',
  16205: '导入的锁编号大于50个字符',
  16206: '导入的锁地点大于100个字符',
  16207: '导入的锁名称在同部门下有重复',
  16208: '导入的锁编号有重复',

  16209: '导入的锁编号必须都是数字',
  16210: '导入的锁编号长度必须是12位',

  16301: '导入的钥匙名称为空',
  16302: '导入的钥匙编号为空',
  16303: '导入的钥匙名称大于50个字符',
  16304: '导入的钥匙编号大于50个字符',
  16305: '导入的钥匙管理人大于50个字符',
  16306: '导入的钥匙名称有重复',
  16307: '导入的钥匙编号有重复',

  16308: '导入的钥匙编号必须都是数字',
  16309: '导入的钥匙编号长度必须是12位',

  // 保存邮件
  17001: '密保邮箱为空',
  17002: '邮箱密码为空',
  17003: '邮箱服务器为空',
  17004: '密保邮箱长度大于50字符',
  17005: '邮箱密码长度大于50字符',
  17006: '邮箱服务器长度大于50字符',

  // 发送
  17007: '找回失败，用户邮箱地址无效',
  17008: '找回失败，密保邮箱服务器无效',
  17009: '找回失败，密保邮箱或密码无效',

  // License
  18004: '导入许可文件格式不正确',
  18005: '服务器与许可文件不匹配',
  18006: '许可文件导入失败',
  18007: '服务器与激活码不匹配',
  18008: '激活码验证失败',
  18009: '请先插入加密狗',
  18010: '分发许可为空',
  18012: '授权期限超出范围（1~100天）',
  18013: '升级版本与当前版本一致',
  18014: '升级版本低于当前版本',
  18015: '激活码验证失败（产品版本信息缺失）',
  18016: '激活码验证失败（产品家族不匹配）',
  18017: '激活码验证失败（授权级别不匹配）',

  // 备份
  19001: '备份失败',
  19002: '还原失败',
  19003: '所选备份文件不存在',
  19004: '导入文件格式不正确',
  19005: '文件内容验证失败，请导入正确的备份文件！',
  19006: '文件不存在',

  // 通讯组件
  19007: '当前通讯组件版本小于等于当前系统中的最新版本，请上传更新版本',
  19008: '请上传正确的文件格式',
  19009: '该文件已存在',
  19010: '文件为空',
  19011: '文件名仅允许字母、数字和下划线',
  19012: '文件大小超出最大限制',

  // App版本
  19101: 'App文件格式不正确',
  19102: '当前App版本小于等于系统中的最新版本，请上传更新版本',
  19103: '上传的APP文件不正确',

  // 权限相关错误：
  40001: '没有权限',
  40002: '身份认证失败，请重新登录...',
  40003: '登录过期，请重新登录...',
  40004: '尚未登录，请登录...',
  // 数据库异常错误：
  50000: '服务器内部错误',

  60000: '指纹数量已超过上限',

  1: '不支持的函数',
  254: '区域验证错误', // TODO: 这个其实就是区域验证错误（国内外不匹配）
  255: '采集指纹失败',
  3001: '指纹采集失败',
  3005: '指纹采集超时',
  4096: '未知设备',
  4097: '未找到设备',
  4098: '通讯过程出现异常（向USB写入数据失败）',
  4099: '通讯过程出现异常（读取USB数据失败）',
  4100: '通讯过程出现异常（打开USB设备失败）',
  4101: '连接设备失败',
  4102: '设备类别错误',
  4105: '创建文件失败',
  4106: '初始化USB失败',
  4108: '写文件失败',
  4109: '设备失去连接',
  4110: '读取的USB数据校验失败',
  4111: '配置USB参数失败',
  4113: '读取超时',
  4114: '参数错误',
  4115: '系统码不匹配',
  4117: '区域验证错误',
  4118: '请先进行初始化',

  20004: '原密码错误',

  21001: '该钥匙盒不存在',
  21002: '钥匙盒名称不能为空',
  21003: '该钥匙盒中有钥匙，不能删除',
  21004: '该钥匙盒正在使用中，不能删除',
  21012: '请先清空所有钥匙，再设置应急孔',
  21103: '该钥匙柜中有钥匙，不能删除',
  21104: '该钥匙柜正在使用中，不能删除',

  24001: '企业信息不存在',
  24002: '企业名称为空',
  24003: '企业编码为空',
  24004: '联系人为空',
  24005: '联系电话为空',
  24006: '软件版本为空',
  24007: '企业名称重复',
  24008: '企业编码重复',
  24009: '该企业软件版本为正式版，不允许删除',
  24010: '该企业下存在已注册的钥匙，不允许删除',
  24011: '该企业下存在已注册的锁，不允许删除',
  24012: '企业管理员不存在',
  24013: '限制数量必须大于等于现有锁具数量',

  // 巡检错误码 30MMEE：01=地点 02=采集地点 03=内容 04=计划

  300101: '巡检地点不存在',
  300102: '请选择部门',
  300103: '请选择地点类型',
  300104: '地点名称不能为空',
  300105: '地点名称最多50字',
  300106: '地点名称不能包含@',
  300107: '地点卡号不能为空',
  300108: '地点卡号最多50字',
  300109: '地点卡号已存在',
  300110: '该部门下已存在同名地点',
  300111: '请填写误差范围',
  300112: '请选择要删除的地点',
  300113: '请选择要转移的地点',
  300114: '部门不存在',

  300201: '采集地点不存在',
  300202: '请选择要入库的采集地点',
  300203: '采集库内地点名称已存在',
  300204: '请选择要删除的采集地点',
  300205: '部门不存在',
  300206: '请选择部门',
  300208: '地点名称为空',
  300209: '地点类型无效',

  300301: '巡检内容不存在',
  300302: '内容标题不能为空',
  300303: '内容标题最多50字',
  300304: '内容标题已存在',
  300305: '内容描述最多200字',
  300306: '提交方式无效',
  300307: '请至少添加一个选项',
  300308: '选项内容不可重复',
  300309: '选项内容最多50字',
  300310: '请选择要删除的巡检内容',
  300311: '请选择巡检内容',
  300312: '锁具不存在',
  300313: '请选择要绑定的地点或锁具',

  300401: '巡检计划不存在',
  300402: '同部门下计划名称不能重复',
  300403: '部门不存在',
  300404: '计划日期无效',
  300405: '请至少选择一个巡检点',
  300406: '请至少添加一条巡检日程',
  300407: '不能将全部日期设为休息日',
  300408: '巡检时间间隔无效',
  300409: '巡检周期或计划次数无效',
  300410: '请选择计划人员',
  300411: '该钥匙已绑定此计划',
  300412: '钥匙不存在',
  300413: '巡检方式无效',
  300414: '巡检点不在允许范围内',
  300415: '计划开始时间过早',
  300416: '请选择要删除的计划',
  300417: '当前选中计划无公共人员',
  300418: '您不在此计划巡检人中',
  300419: '仅钥匙巡检方式计划可派发或领用钥匙',

  300501: '巡检数据不存在',
  300502: '上传记录不能为空',
  300503: '巡检目标不存在',
  300504: '巡检计划不存在',
  300505: '钥匙不存在',
  300506: '数据来源无效',
  300507: '巡检时间无效',
  300508: '巡检人员不存在',
  300509: '上传失败',

  300601: '巡检报告不存在',
  300602: '报告明细不存在',
};

export default ExceptionCodes;
